export default __webpack_public_path__ + "static/media/parmesan_cheese.b25940c9.jpeg";